import React from "react";
import './Body20.css';
import {Link} from "react-router-dom"
import picture320 from './source/picture320.png'
import picture321 from './source/picture321.png'
import picture322 from './source/picture322.png'
import picture323 from './source/picture323.png'





function Body20() {

  return (
    <div className="body20">
      <div className="body20-box1">
        <div className="body20-box2">
          <div className="body20-box3">Malenovice</div>
          <div className="body20-box5"><div className="body20-box4"></div></div>
          <div className="body20-box6">
          <img className="body20-box6-picture2" src={picture321} alt="picture1"/>
          <img className="body20-box6-picture2" src={picture322} alt="picture1"/>
          <img className="body20-box6-picture2" src={picture323} alt="picture1"/>
          <img className="body20-box6-picture" src={picture320} alt="picture1"/>
          </div>
          <div className="body20-box8"><div className="body20-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body20;
